"use client";

import Markdown from "@/components/atoms/Markdown";
import styles from "./styles.module.scss";
import Image from "next/image";
import ProgramsWithFilter from "@organisms/ProgramsWithFilter/ProgramsWithFilter";
import { useCallback, useState } from "react";
import cn from "clsx";
import ProgramFiltersMenu from "@organisms/ProgramFiltersMenu/ProgramFiltersMenu";
import ProgramsSearch from "@organisms/ProgramsSearch/ProgramsSearch";

export default function ProgramListingTemplate({ programs, Title, isDesktop, isProgramSpecific=false, isCertification = false, domain= "", offeredBy = "" }) {
 
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [filteredPrograms, setFilteredPrograms] = useState(programs);
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [previousPrograms, setPreviousPrograms] = useState(programs);
  const [query,setQuery] = useState("");
  const toggleScroll = (flag: boolean) => {
    const htmlEl = document.querySelector("html");
    if (flag) {
      htmlEl.style.overflowY = "hidden";
    } else {
      htmlEl.style.overflowY = "auto";
    }
  };

  const toggleFilters = useCallback(
    (e) => {
      toggleScroll(!isFiltersOpen && !isDesktop);
      setIsFiltersOpen(!isFiltersOpen);
    },
    [isFiltersOpen]
  );
  
  return (
    <>
      <div className={styles.titleContainer}>
        {isProgramSpecific ? (<h1><Markdown className={styles.title}>{Title}</Markdown></h1>) :
          Title?.enabled ? (
            <h1><Markdown className={styles.title}>{Title?.text}</Markdown></h1>
          ) : null
        }
        <div className={styles.filtersContainer}>
          <div
            className={cn({
              [styles.activeFilters]: isFiltersApplied && !isDesktop,
            })}
          >
            <Image
              src="/_a/icons/filters.svg"
              alt="Filters"
              height={30}
              width={30}
              className={styles.filtersLogo}
              onClick={toggleFilters}
            />
          </div>
          <ProgramsSearch
            programs={previousPrograms}
            setFilteredPrograms={setFilteredPrograms}
            previousPrograms={previousPrograms}
            query={query}
            setQuery={setQuery}
          />
        </div>
      </div>
      <ProgramsWithFilter
        programs={programs}
        filteredPrograms={filteredPrograms}
        isDesktop={isDesktop}
        toggleFilters={toggleFilters}
        isFiltersOpen={isFiltersOpen}
        setFilteredPrograms={setFilteredPrograms}
        setIsFiltersApplied={setIsFiltersApplied}
        isFiltersApplied={isFiltersApplied}
        isProgramSpecific={isProgramSpecific}
        setPreviousPrograms={setPreviousPrograms}
        query={query}
        setQuery={setQuery}
        isCertification={isCertification}
        domain={domain}
        offeredBy={offeredBy}
      />
      <div
        className={cn(styles.filters, {
          ["!max-w-0"]: !isFiltersOpen || isDesktop,
        })}
      >
        <div className={styles.filterContainer}>
          <ProgramFiltersMenu
            programs={programs}
            toggleFilters={toggleFilters}
            setFilteredPrograms={setFilteredPrograms}
            setIsFiltersApplied={setIsFiltersApplied}
            isProgramSpecific={isProgramSpecific}
            setPreviousPrograms={setPreviousPrograms}
            query={query}
            setQuery={setQuery}
            domain={domain}
            offeredBy={offeredBy}
          />
        </div>
      </div>
    </>
  );
}
